var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.34 6.82018L14.58 2.79018C13.01 1.69018 10.6 1.75018 9.09004 2.92018L4.08004 6.83018C3.08004 7.61018 2.29004 9.21018 2.29004 10.4702V17.3702C2.29004 19.9202 4.36004 22.0002 6.91004 22.0002H17.69C20.24 22.0002 22.31 19.9302 22.31 17.3802V10.6002C22.31 9.25018 21.44 7.59018 20.34 6.82018ZM13.05 18.0002C13.05 18.4102 12.71 18.7502 12.3 18.7502C11.89 18.7502 11.55 18.4102 11.55 18.0002V15.0002C11.55 14.5902 11.89 14.2502 12.3 14.2502C12.71 14.2502 13.05 14.5902 13.05 15.0002V18.0002Z",
    fill: "url(#paint0_linear_6917_1720)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6917_1720",
    x1: 12.3,
    y1: 2.00244,
    x2: 12.3,
    y2: 22.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/homeActive.bde8fdee902c29b5da0417c1702e3517.svg";
export { ForwardRef as ReactComponent };